import React from "react";
import Chart from "react-apexcharts";

function formatMoney(v) {
    return Number(v || 0).toLocaleString("en-IN", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
}

export default function IncomeExpenseChart({ kpi = {} }) {

    const income = Math.abs(Number(kpi.income || 0));
    const expense = Math.abs(Number(kpi.expense || 0));

    const series = [income, expense];

    const options = {
        chart: {
            type: "donut",
            toolbar: { show: false },
        },

        labels: ["Income", "Expense"],

        colors: ["#27AE60", "#EB5757"],

        legend: {
            position: "bottom",
            fontSize: "13px",
            markers: { radius: 4 },
        },

        dataLabels: {
            enabled: true,
            formatter: function (val, opts) {
                const value = opts.w.config.series[opts.seriesIndex];
                return "₹ " + formatMoney(value);
            },
            style: {
                fontSize: "12px",
                fontWeight: 600,
            },
        },

        plotOptions: {
            pie: {
                donut: {
                    size: "65%",
                    labels: {
                        show: true,
                        total: {
                            show: true,
                            label: "Net",
                            formatter: function () {
                                const net = expense - income;
                                return "₹ " + formatMoney(Math.abs(net));
                            },
                        },
                    },
                },
            },
        },

        tooltip: {
            y: {
                formatter: (val) => "₹ " + formatMoney(val),
            },
        },
    };

    return (
        <div className="w-100 d-flex flex-column align-items-center">
            <Chart
                options={options}
                series={series}
                type="donut"
                height={260}
            />

            {/* Accounting Net Label */}
            <div className="mt-2 small fw-semibold">
                {expense > income ? (
                    <span className="text-danger">
                        Net Loss ₹ {formatMoney(expense - income)}
                    </span>
                ) : income > expense ? (
                    <span className="text-success">
                        Net Profit ₹ {formatMoney(income - expense)}
                    </span>
                ) : (
                    <span className="text-muted">Break Even</span>
                )}
            </div>
        </div>
    );
}